import { useEffect, useState } from 'react'
import MapView from './components/MapView'
import './App.css'

const SMOOTH_CONTOURS_STORAGE_KEY = 'navica_smooth_contours'

function App() {
  const [showBathymetry, setShowBathymetry] = useState(true)
  const [smoothContours, setSmoothContours] = useState<boolean>(() => {
    try {
      if (typeof window === 'undefined') return true
      const raw = window.localStorage.getItem(SMOOTH_CONTOURS_STORAGE_KEY)
      if (raw === null) return true
      return raw === '1'
    } catch {
      return true
    }
  })
  const isE2E = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('e2e')

  useEffect(() => {
    try {
      window.localStorage.setItem(SMOOTH_CONTOURS_STORAGE_KEY, smoothContours ? '1' : '0')
    } catch {
      // ignore
    }
  }, [smoothContours])

  return (
    <div className="app">
      <header className="app-header">
        <h1>{isE2E ? 'Boating App (E2E)' : 'Boating App Navigator'}</h1>
        <div className="controls">
          <button onClick={() => setShowBathymetry(!showBathymetry)}>
            {showBathymetry ? 'Hide' : 'Show'} Bathymetry
          </button>
          <label className="checkbox-control" title="Smooth contour lines">
            <input
              type="checkbox"
              checked={smoothContours}
              onChange={(e) => setSmoothContours(e.target.checked)}
            />
            Smooth
          </label>
        </div>
      </header>
      <main className="app-main">
        <MapView showBathymetry={showBathymetry} smoothContours={smoothContours} />
      </main>
    </div>
  )
}

export default App
